import { Component, Input, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '../security/authentication.service';
import { AlertService } from '../shared/alert/alert.service';
import { SpinnerService } from '../shared/spinner/spinner.service';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { User } from '../entity/user';

@Component({
  selector: 'login',
  templateUrl: './login.component.html'
})
export class LoginComponent {
  @ViewChild('signupModal') public signupModal:ModalDirective;

  constructor(private router: Router, private authenticationService: AuthenticationService, private alertService: AlertService, private spinnerService: SpinnerService) { }

  login(event, username, password): void {
    event.preventDefault();
    this.spinnerService.start("Connexion");
    this.authenticationService.login(username, password)
      .then(function(response){
        if(response.success){
          this.router.navigate(['']);
          // this.alertService.success(response.message);
        } else {
          this.alertService.error(response.message);
        }
        this.spinnerService.stop();
      }.bind(this));
  }

  showSignupModal(event): void {
    event.preventDefault();
    this.signupModal.show();
  }

  redirectToSignup(event): void {
    event.preventDefault();
    this.router.navigate(['signup']);
  }
  
}


// WEBPACK FOOTER //
// ./src/app/login/login.component.ts